/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { LockIcon } from '@chegg-ui/horizon-icons';
import { Button, SecondaryButton } from '@chegg-ui/button';
import { CtaContainer } from './styled';
import { onCtaButtonClick, getCTAButtonText } from './helpers';
import { Strings } from './strings';
import { renderSecondaryButton } from './variants/SecondaryButton';
import { getErrorMessage } from '../../utils/ErrorUtil';
import { Components } from '../../common/interfaces';
var Cta = function Cta(_ref) {
  var content = _ref.content,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    loading = _ref.loading,
    onRioEventFired = _ref.onRioEventFired,
    onError = _ref.onError,
    namespace = _ref.namespace,
    isReview = _ref.isReview,
    hideLockIcon = _ref.hideLockIcon,
    isUpgrade = _ref.isUpgrade,
    isSecondary = _ref.isSecondary;
  if (!content) {
    return null;
  }
  if (!content.cta) {
    onError(getErrorMessage(Components.CTA, "".concat(Strings.MISSING_CONTENT_ERROR)));
    return null;
  }
  var secondaryCta = content.secondaryCta || '';
  var cta = getCTAButtonText(content, !!isReview, !!isUpgrade);
  var onClickHandler = function onClickHandler(event) {
    onCtaButtonClick({
      event: event,
      isReview: isReview,
      namespace: namespace,
      onClick: onClick,
      onRioEventFired: onRioEventFired
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CtaContainer, null, isSecondary ? renderSecondaryButton({
    cta: secondaryCta,
    isDisabled: disabled,
    loading: loading,
    onClick: onClick
  }) : isReview ? /*#__PURE__*/React.createElement(SecondaryButton, {
    "data-test": 'CTA_BUTTON',
    onClick: function onClick(event) {
      return onClickHandler(event);
    },
    disabled: disabled,
    isLoading: loading,
    disableHoverAnimation: true,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement("span", null, cta)) : /*#__PURE__*/React.createElement(Button, {
    "data-test": 'CTA_BUTTON',
    onClick: function onClick(event) {
      return onClickHandler(event);
    },
    disabled: disabled,
    isLoading: loading,
    disableHoverAnimation: true,
    size: 'medium'
  }, !hideLockIcon && /*#__PURE__*/React.createElement(LockIcon, {
    size: 'small',
    "data-test": 'CT_LOCK_ICON',
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement("span", null, cta))));
};
export default /*#__PURE__*/React.memo(Cta);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/CTA/index.js
// module id = 3517
// module chunks = 11